import { render } from "./SideArea.vue?vue&type=template&id=5ba9b82e&scoped=true"
import script from "./SideArea.vue?vue&type=script&lang=js"
export * from "./SideArea.vue?vue&type=script&lang=js"

import "./SideArea.vue?vue&type=style&index=0&id=5ba9b82e&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba9b82e"]])

export default __exports__